import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const download = (theme: Theme) => css`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${size[16]};
  padding: ${size[40]};
  margin: auto -${size[24]} 0 -${size[24]};

  ${breakpoint.up('smMd')} {
    background: ${theme.palette.additionalColor.downloadWidget};
    gap: ${size[24]};
    width: 100%;
    min-width: 360px;
    margin: -${size[54]} 0;
    padding: ${size[54]} ${size[48]};
    height: calc(100% + 108px);
  }
`

export const qrCode = css`
  width: ${size[96]};
  height: ${size[96]};
`

export const headline = (theme: Theme) => css`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.palette.neutral[900]};
  line-height: 1.5;
  margin: 0;
`
export const stores = css`
  display: flex;
  gap: ${size[8]};
  justify-content: center;
  flex-wrap: wrap;

  ${breakpoint.up('md')} {
    gap: ${size[16]};
    justify-content: space-between;
    flex-wrap: nowrap;
  }
`
